import * as userActions from '../user/actions';
import * as newsCategoriesActions from './actions';
import { CLEAN_PERSISTED_STORAGE } from '~redux_related/GENERAL/actions';

const initialState = {
    list: null,
    isFetching: false,
    isLoaded: false,
    error: '',
};

export const newsDigestsCategoriesReducer = (state = initialState, action) => {
    switch (action.type) {
        case newsCategoriesActions.SET_NEWS_DIGESTS_CATEGORIES_FETCHING:
            return {
                ...state,
                isFetching: action.isFetching,
            };

        case newsCategoriesActions.SET_NEWS_DIGESTS_CATEGORIES_ERROR:
            return {
                ...initialState,
                isLoaded: true,
                error: action.error,
            };

        case newsCategoriesActions.SET_NEWS_DIGESTS_ALL_CATEGORIES:
            return {
                list: action.list,
                isFetching: false,
                isLoaded: true,
                error: '',
            };

        case newsCategoriesActions.ABORT_NEWS_DIGESTS_CATEGORIES_REQUEST:
            return initialState;

        case newsCategoriesActions.CLEAN_NEWS_DIGESTS_CATEGORIES:
            return initialState;

        case userActions.LOGOUT:
            return initialState;

        case userActions.LOGIN:
            // console.log('+++LOGIN USER 28+++');
            return initialState;

        case CLEAN_PERSISTED_STORAGE:
            console.log('+++CLEAN PERSISTED STORAGE 32+++');
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/redux_related/newsDigestsCategories/reducer.js